module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": "添加新域",
      "width": "35%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "namespaceInfo",
    attrs: {
      "model": _vm.namespaceInfo,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "zk集群",
      "prop": "zkClusterKey"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.namespaceInfo.zkClusterKey),
      callback: function($$v) {
        _vm.$set(_vm.namespaceInfo, "zkClusterKey", $$v)
      },
      expression: "namespaceInfo.zkClusterKey"
    }
  }, _vm._l((_vm.onLineClusters), function(item) {
    return _c('el-option', {
      key: item.zkClusterKey,
      attrs: {
        "label": item.zkAlias,
        "value": item.zkClusterKey
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "域名",
      "prop": "namespace"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.namespaceInfo.namespace),
      callback: function($$v) {
        _vm.$set(_vm.namespaceInfo, "namespace", $$v)
      },
      expression: "namespaceInfo.namespace"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-890b350e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/registry_manage/namespace_info_dialog.vue
// module id = 1432
// module chunks = 1